<div class="content">
  <span class="mat-title">Suas informações pessoais</span>

  <form [formGroup]="formUser" (submit)="submit()">
    <div class="actions" style="padding: 10px; flex-direction: row">
      <button
        mat-stroked-button
        color="primary"
        type="button"
        (click)="editable()"
        *ngIf="!formEditable"
      >
        <mat-icon>edit</mat-icon>
        Editar
      </button>
      <button
        mat-stroked-button
        color="warn"
        type="button"
        (click)="editable(false)"
        *ngIf="formEditable"
      >
        <mat-icon>close</mat-icon>
        Cancelar
      </button>
      <!-- <button
        mat-raised-button
        class="custom-primary"
        type="submit"
        [disabled]="formUser.pristine"
      >
        Atualizar
      </button> -->
      <button
        mat-raised-button
        color="warn"
        (click)="excluir_conta()"
        type="button"
      >
        <mat-icon>delete_forever</mat-icon>
        Excluir Conta
      </button>
    </div>

    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Primeiro nome</mat-label>
        <input
          type="text"
          placeholder="Seu primeiro nome"
          matInput
          formControlName="firstname"
          [readonly]="!formEditable"
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Sobrenome</mat-label>
        <input
          type="text"
          placeholder="Seu sobrenome"
          matInput
          formControlName="lastname"
          [readonly]="!formEditable"
        />
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>CPF</mat-label>
        <input
          matInput
          type="text"
          placeholder="Informe seu cpf"
          mask="000.000.000-00"
          formControlName="cpf"
          [readonly]="!formEditable"
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Celular/Whatsapp</mat-label>
        <input
          matInput
          type="phone"
          placeholder="Informe seu numero de telefone"
          mask="(00) 00000 0000"
          formControlName="phone"
          [readonly]="!formEditable"
        />
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Sexo</mat-label>
        <mat-select
          matInput
          required
          placeholder="Informe seu sexo"
          formControlName="gender"
          [disabled]="!formEditable"
        >
          <mat-option value="masculino">Masculino</mat-option>
          <mat-option value="feminino">Feminino</mat-option>
          <mat-option value="outros">Outros</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Data de nascimento</mat-label>
        <input
          matInput
          type="date"
          placeholder="Informe sua data de nascimento"
          formControlName="birthday"
          [readonly]="!formEditable"
        />
      </mat-form-field>
    </div>

    <fieldset>
      <legend>Endereço</legend>

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>CEP</mat-label>
          <input
            matInput
            type="text"
            placeholder="Informe seu cep"
            mask="00.000-000"
            formControlName="zipCode"
            [readonly]="!formEditable"
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Estado</mat-label>
          <mat-select
            matInput
            placeholder="Informe seu estado"
            formControlName="state"
            [disabled]="!formEditable"
          >
            <ng-container *ngFor="let state of states">
              <mat-option [value]="state.sigla">{{ state.nome }}</mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Cidade</mat-label>
          <input
            matInput
            type="text"
            placeholder="Informe sua cidade"
            formControlName="city"
            [readonly]="!formEditable"
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Bairro</mat-label>
          <input
            matInput
            type="text"
            placeholder="Informe seu bairro"
            formControlName="district"
            [readonly]="!formEditable"
          />
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Rua/avenida</mat-label>
          <input
            matInput
            type="text"
            placeholder="Informe a rua/avenida"
            formControlName="street"
            [readonly]="!formEditable"
          />
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Numero de residência</mat-label>
          <input
            matInput
            type="text"
            placeholder="Informe numero da sua residência"
            formControlName="number"
            [readonly]="!formEditable"
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Complemento</mat-label>
          <input
            matInput
            type="text"
            placeholder="Informe o complemento"
            formControlName="complement"
            [readonly]="!formEditable"
          />
        </mat-form-field>
      </div>
    </fieldset>

    <div class="actions">
      <button
        mat-raised-button
        class="custom-primary"
        type="submit"
        [disabled]="formUser.pristine"
      >
        Atualizar
      </button>
    </div>
  </form>
  <hr />

  <span class="mat-title">Informações da empresa</span>

  <form [formGroup]="formCompany" (submit)="submitCompany()">
    <div class="actions" style="padding: 10px; flex-direction: row">
      <button
        mat-stroked-button
        color="primary"
        type="button"
        (click)="editableCompany()"
        *ngIf="!formCompanyEditable"
      >
        <mat-icon>edit</mat-icon>
        Editar
      </button>
      <button
        mat-stroked-button
        color="warn"
        type="button"
        (click)="editableCompany(false)"
        *ngIf="formCompanyEditable"
      >
        <mat-icon>close</mat-icon>
        Cancelar
      </button>
      <!-- <button
        mat-raised-button
        class="custom-primary"
        type="submit"
        [disabled]="formCompany.pristine"
      >
        Atualizar
      </button> -->
    </div>

    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Nome Fantasia</mat-label>
        <input
          type="text"
          placeholder="Nome fantasia da sua empresa"
          matInput
          formControlName="businessName"
          [readonly]="!formCompanyEditable"
        />
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Razao social</mat-label>
        <input
          type="text"
          placeholder="Razao social"
          matInput
          formControlName="companyName"
          [readonly]="!formCompanyEditable"
        />
      </mat-form-field>
    
      <mat-form-field appearance="outline">
        <mat-label>Telefone</mat-label>
        <input
        matInput
        type="phone"
        placeholder="Informe o número de telefone"
        mask="(00) 00000 0000"
        formControlName="companyphone"
        inputmode="numeric"
        [readonly]="!formCompanyEditable"
        />
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Email da empresa (e usuario admin)</mat-label>
        <input
          type="email"
          placeholder="Email de acesso"
          matInput
          formControlName="email"
          [readonly]="!formCompanyEditable"
        />
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>CNPJ</mat-label>
        <input
          type="text"
          placeholder="CNPJ da empresa"
          matInput
          formControlName="cnpj"
          [readonly]="!formCompanyEditable"
          mask="00.000.000/0000-00"
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Regime tributário</mat-label>
        <mat-select
          matInput
          aria-placeholder="Regime tributário"
          formControlName="taxRegime"
          [disabled]="!formCompanyEditable"
        >
          <mat-option value="simples_nacional">Simples Nacional</mat-option>
          <mat-option value="lucro_presumido">Lucro Presumido</mat-option>
          <mat-option value="lucro_real">Lucro Real</mat-option>
        </mat-select>
      </mat-form-field>      
    </div>

    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Inscrição municipal</mat-label>
        <input
          type="text"
          placeholder="Inscrição municipal"
          matInput
          formControlName="im"
          [readonly]="!formCompanyEditable"
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Inscrição estadual</mat-label>
        <input
          type="text"
          placeholder="Inscrição estadual"
          matInput
          formControlName="ie"
          [readonly]="!formCompanyEditable"
        />
      </mat-form-field>
    </div>

    <fieldset>
      <legend>Endereço da empresa</legend>

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Cep da empresa</mat-label>
          <input
            type="text"
            matInput
            placeholder="Informe o cep da empresa"
            formControlName="zipCode"
            [readonly]="!formCompanyEditable"
            mask="00000-000"
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Estado</mat-label>
          <mat-select
            matInput
            placeholder="Escolha o estado"
            formControlName="state"
            [disabled]="!formCompanyEditable"
          >
            <ng-container *ngFor="let state of states">
              <mat-option [value]="state">{{ state.nome }}</mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Cidade</mat-label>
          <mat-select
            matInput
            formControlName="city"
            [disabled]="!formCompanyEditable"
          >
            <ng-container *ngFor="let city of cities$ | async">
              <mat-option [value]="city.name">{{ city.name }}</mat-option>
            </ng-container>
          </mat-select>
          <mat-hint>Escolha o estado para mostrar as cidades</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Bairro</mat-label>
          <input
            matInput
            type="text"
            placeholder="Informe seu bairro"
            formControlName="district"
            [readonly]="!formCompanyEditable"
          />
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Rua/avenida</mat-label>
          <input
            matInput
            type="text"
            placeholder="Informe a rua/avenida"
            formControlName="street"
            [readonly]="!formCompanyEditable"
          />
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Numero de residência</mat-label>
          <input
            matInput
            type="text"
            placeholder="Informe numero da sua residência"
            formControlName="number"
            [readonly]="!formCompanyEditable"
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Complemento</mat-label>
          <input
            matInput
            type="text"
            placeholder="Informe o complemento"
            formControlName="complement"
            [readonly]="!formCompanyEditable"
          />
        </mat-form-field>
      </div>
    </fieldset>

    <fieldset>
      <legend>Social</legend>

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Site da empresa</mat-label>
          <input
            type="text"
            matInput
            placeholder="Site da empresa"
            formControlName="site"
            [readonly]="!formCompanyEditable"
          />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Facebook</mat-label>
          <input
            type="text"
            matInput
            placeholder="Facebook"
            formControlName="facebook"
            [readonly]="!formCompanyEditable"
          />
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Instagram</mat-label>
          <input
            type="text"
            matInput
            placeholder="Instagram"
            formControlName="instagram"
            [readonly]="!formCompanyEditable"
          />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Youtube</mat-label>
          <input
            type="text"
            matInput
            placeholder="Youtube"
            formControlName="youtube"
            [readonly]="!formCompanyEditable"
          />
        </mat-form-field>
      </div>
    </fieldset>

    <div class="actions">
      <button
        mat-raised-button
        class="custom-primary"
        type="submit"
        [disabled]="formCompany.pristine"
      >
        Atualizar
      </button>
    </div>
  </form>
</div>
